import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import TextField from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { signInExistingAccountStyles } from "@tKgpco/Overrides/Widgets/SignIn/SignInExistingAccount";
import React, { useEffect, useState } from "react";       
import { css } from "styled-components";

const enum fields {
    formAction = "formAction",
    hiddenUrl= "hiddenUrl",
    forgotPasswordUrl= "forgotPasswordUrl",
    createAccountUrl = "createAccountUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.formAction]: string;
        [fields.forgotPasswordUrl]: string;
        [fields.hiddenUrl]: string;
        [fields.createAccountUrl]: string;
    };
}

export interface SignInEcomStyles {
    hiddenWrap?: InjectableCss;
    signInGridContainer?: GridContainerProps;
    signInButtonGridItem?: GridItemProps;
}

export const SignInEcomStyles: SignInEcomStyles = {
    hiddenWrap: {
        css: css`
            display: none;
        `,
    },
    signInGridContainer: {
        css: css`
            > ${GridOffset} {
                width: calc(100% + 30px) !important;`,
    },
    signInButtonGridItem: {
        width: 12,
    },
};

type Props = OwnProps & WidgetProps;

const SignInEcom: React.FC<Props> = ({ fields }) => { 
    const styles = SignInEcomStyles;

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    useEffect(()=>{
        const pageUrl = window.location.href;
        if(pageUrl.includes("error=true"))
        {
            // eslint-disable-next-line no-alert
            alert(siteMessage("SignInInfo_LoginFailed"))
        }  
    },[])
    
    const usernameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUsername(e.currentTarget.value);
    };

    const passwordChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.currentTarget.value);
    };

    const validateLoginForm = (e: any) => {
        if (!username) {
            e.preventDefault();
            // eslint-disable-next-line no-alert
            alert("Please enter a valid username.");
            return false;
        }
        if (!password) {       
            e.preventDefault();
            // eslint-disable-next-line no-alert
            alert("Please enter a valid password.");
            return false;
        }
        if (password.length < 5 || password.length > 15) {
            e.preventDefault();
            // eslint-disable-next-line no-alert
            alert("Your password must be between 5 and 15 characters in length.");
            return false;
        }
        return true;
    };

    return (
        <StyledWrapper>
            <Typography {...signInExistingAccountStyles.signInExistingAccountTitle}>
                {translate("Already have an account?")}
            </Typography>
            <StyledWrapper {...signInExistingAccountStyles.container}>
                <form
                    name="login"
                    action={fields.formAction}
                    method="post"
                    onSubmit={e => validateLoginForm(e)}
                >
                    <GridContainer {...styles.signInGridContainer}>
                        <GridItem {...styles.hiddenWrap}>
                            <TextField
                                value={fields.hiddenUrl}
                                name="target"
                                type="hidden"
                            />
                            <TextField value={0} name="SMAUTHREASON" type="hidden" />
                        </GridItem>
                        <GridItem {...signInExistingAccountStyles.userNameGridItem}>
                            <TextField
                                {...signInExistingAccountStyles.userNameTextField}
                                placeholder={translate("Enter your username")}
                                name="user_code"
                                id="user_code"
                                type="text"
                                label={translate("User Name:")}
                                size={23}
                                max={50}
                                value={username}
                                onChange={usernameChangeHandler}
                            />
                        </GridItem>
                        <GridItem {...signInExistingAccountStyles.passwordGridItem}>
                            <TextField
                                {...signInExistingAccountStyles.passwordTextField}
                                placeholder={translate("Enter your password")}
                                name="PASSWORD"
                                id="PASSWORD"
                                type="password"
                                data-test-selector="signIn_password"
                                label={translate("Password:")}
                                size={23}
                                max={50}
                                value={password}
                                onChange={passwordChangeHandler}
                            />
                        </GridItem>
                        <GridItem {...styles.signInButtonGridItem}>
                            <Button {...signInExistingAccountStyles.signInButton} type="submit" value="SIGN-IN">
                                sign in
                            </Button>
                        </GridItem>
                        <GridItem {...signInExistingAccountStyles.signInButtonGridItem}>
                            <Link
                                {...signInExistingAccountStyles.forgotPasswordLink}
                                href={fields.forgotPasswordUrl}
                            >
                                Forgot password?
                            </Link>
                        </GridItem>
                    </GridContainer>
                </form>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const signInEcom: WidgetModule = {
    component: SignInEcom,
    definition: {
        group: "Header",
        fieldDefinitions: [
            {
                name: fields.formAction,
                fieldType: "Translatable",
                editorTemplate: "MultilineTextField",
                displayName: "Form Action URL",
                isRequired: true,
                defaultValue: "",
            },
            {
                name: fields.hiddenUrl,
                fieldType: "Translatable",
                editorTemplate: "MultilineTextField",
                displayName: "Hidden URL",
                isRequired: true,
                defaultValue: "",
            },
            {
                name: fields.forgotPasswordUrl,
                fieldType: "Translatable",
                editorTemplate: "MultilineTextField",
                displayName: "Forgot Password URL",
                isRequired: true,
                defaultValue: "",
            },
        ],
    },
};
export default signInEcom;
